import useAlias from '@alias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { SiteMeta } from '@src/types/SiteMeta';
import { SavedSearch } from '@types';
import { currentTzString } from '@utils';
import { ReactElement } from 'react';
import { AggregationInput } from './AggregationInput';
import DateTimePicker from './DateTimePicker';
import { checkShouldAggr } from './historianUtils';
import { IntervalInputs } from './IntervalInputs';

const s = {
  gridTimeStamp: {
    alignItems: 'center',
  },
  label: {
    lineHeight: '1',
    paddingTop: 20,
  },
} as const;

interface SettingsRowProps {
  siteMeta: SiteMeta;
  timeMode: string;
  activeSearch: SavedSearch;
  setSearchField: <T>(field: string, value: T) => void;
}
function SettingsRow(props: SettingsRowProps): ReactElement {
  const alias = useAlias();
  const { siteMeta, timeMode, activeSearch, setSearchField } = props;
  const currentTz = currentTzString({
    timeMode,
    lat: siteMeta.GPSLat,
    long: siteMeta.GPSLong,
  });
  const aggrMessage =
    !checkShouldAggr(activeSearch) && alias('Displayed aggregation types');
  return (
    <>
      <div className='label' style={s.label}>
        <FormattedAlias id='Timestamp' />
        <br />
        <br />
        <span>{currentTz}</span>
      </div>
      <div className='inputs-row no-pd-top with-buttons-search'>
        <div style={s.gridTimeStamp} className='grid-timestamp'>
          <div className='small-lable'>
            <FormattedAlias id='From' />
          </div>
          <div className='small-lable' />
          <div className='small-lable'>
            <FormattedAlias id='To' />
          </div>
          <div className='small-lable pd-l'>
            <FormattedAlias id='Interval' />
          </div>
          <div className='small-lable pd-l'>{aggrMessage}</div>
          <DateTimePicker
            field='startDateTime'
            activeSearch={activeSearch}
            setSearchField={setSearchField}
          />
          <div>&nbsp;-&nbsp;</div>
          <DateTimePicker
            field='stopDateTime'
            activeSearch={activeSearch}
            setSearchField={setSearchField}
          />
          <div className='pd-l dis'>
            <IntervalInputs
              interval={activeSearch.interval}
              setSearchField={setSearchField}
              activeSearch={activeSearch}
            />
          </div>
          <div className='pd-l dis'>
            {!checkShouldAggr(activeSearch) && (
              <AggregationInput
                setSearchField={setSearchField}
                activeSearch={activeSearch}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SettingsRow;
